import { useResourcePermissions, type ResourcePermissions } from './useResourcePermissions';
export type InitiativePermissions = ResourcePermissions;

/**
 * Hook to get current user's permissions for an initiative.
 * Convenience wrapper around useResourcePermissions.
 */
export function useInitiativePermissions(initiativeId) {
  return useResourcePermissions("initiative", initiativeId);
}